import React, { forwardRef, HtmlHTMLAttributes, memo, ReactNode } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

export type FooterType = "card" | "section"

export type SectionFooterPropsType = HtmlHTMLAttributes<HTMLDivElement> & {
  actions?: ReactNode | ReactNode[]
  type?: FooterType
  divider?: boolean
  actionsClassName?: string
  tabsClassName?: string
}

export const SectionFooter = memo(forwardRef<HTMLDivElement, SectionFooterPropsType>((
  {
    type = "section",
    actions,
    divider = false,
    className,
    actionsClassName,
    tabsClassName,
    children,
    ...props
  }, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      className={classNames(
        className,
        styles.root,
        {
          [styles.divider]: divider,
          [styles.card]: type === "card",
          [styles.section]: type === "section",
        },
      )}
    >
      <div className={classNames(styles.tabs, tabsClassName)}>{children}</div>
      <div className={classNames(styles.actions, actionsClassName)}>{actions}</div>
    </div>
  );
}));
